import { useParams } from "react-router-dom";
import { useLiveQuery } from "@/core/hooks/useLiveQuery";
import { PageLayout } from "@/components/templates/page-layout";
import { SiteForm } from "@/components/organisms/site-form";
import { useSites } from "@/core/hooks/useSites";
import { offlineDb } from "@/core/offline/db";

export default function ModifierSitePage() {
  const { siteId } = useParams<{ siteId: string }>();
  const { updateSite } = useSites();
  const site = useLiveQuery(() => offlineDb.sites.get(siteId!), [siteId]);

  if (!site) {
    return (
      <PageLayout title="Modifier le site">
        <p className="text-muted-foreground">Site introuvable.</p>
      </PageLayout>
    );
  }

  return (
    <PageLayout title="Modifier le site">
      <SiteForm
        defaultValues={{
          name: site.name,
          client: site.client ?? undefined,
          address: site.address ?? undefined,
        }}
        onSubmit={async (data) => {
          await updateSite(siteId!, data);
        }}
      />
    </PageLayout>
  );
}
